import React from 'react';
import PropTypes from 'prop-types';
import Paper from 'material-ui/Paper';
import Divider from 'material-ui/Divider';
import { typography } from 'material-ui/styles';
import styled from 'styled-components';

/*
  Styled components
 */
const PaperStyled = styled(Paper)`
  padding: 30px;
`;

const Title = styled.h3`
  font-size: 24px;
  font-weight: ${typography.fontWeightLight};
  margin-bottom: 20px;
  display: inline-block;
`;

/*
  PropTypes / DefaultProps
 */

const propTypes = {
  children: PropTypes.element,
  title: PropTypes.any,
  rightComponent: PropTypes.any,
  className: PropTypes.any,
};

const defaultProps = {
  title: '',
};

const PageBase = (props) => {
  const { title, rightComponent } = props;

  return (
    <div className={props.className}>
      <PaperStyled>
        <Title>{title}</Title>
        <div style={{ float: 'right' }}>{rightComponent}</div>

        <Divider />
        {props.children}

        <div className="clear" />
      </PaperStyled>
    </div>
  );
};

PageBase.propTypes = propTypes;
PageBase.defaultProps = defaultProps;

export default PageBase;



// WEBPACK FOOTER //
// ./src/components/PageBase.js